/* 🤖 this file was generated by svg-to-ts*/
export const iconShare = {
  name: 'share',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M14.204 7.797v-1.59c0-.89 1.08-1.34 1.71-.71l4.59 4.59c.39.39.39 1.02 0 1.41l-4.59 4.59c-.63.63-1.71.19-1.71-.7v-1.69c-5 0-8.5 1.6-11 5.1 1-5 4-10 11-11z"/></svg>`,
}
